export interface ContactPhoneDto {
  contactType: ContactPhoneType;

  data: string;

  fiveNinePhone: string;

  id: number;

  prime: boolean;

  updatedDate: number;

  userEnteredData: string;
}

export enum ContactPhoneType {
  CELL = 'CELL',

  HOME = 'PHONE',
}



// WEBPACK FOOTER //
// ./ts/app/shared/types/ContactPhoneDto.ts